import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import type {
  User,
  AuthenticationsState,
  AdminUser,
  UserDataForActivate,
} from "@/types";
import axios, { AxiosError } from 'axios';
import {
  loginURL,
  createUserURL,
  activateUserURL,
  logoutUserURL,
} from "../../constants";


interface ErrorMessage {
  error: string;
  message: string;
}

interface LoginData {
  email: string | undefined;
  password: string | undefined;
}

interface UserDataForLogoutUser{
  token: string | null;
}

export const initialValuesForActivate = {
  activateCode: "",
  password: "",
  password2: "",
}

export const initialValuesLoginUserData = {
  email:"",
  password:"",
}



export const initialState: AuthenticationsState = {
  status: 'idle',
  activateUserStatus: 'idle',
  error: undefined,
  message: undefined,
  createAdminStatus: 'idle',
  loginStatus: 'idle',
  tokenValid: true,
  user: {
    token:null,
    email: undefined,
    userRole: undefined,
    userID: undefined,
    username: undefined,
    firstName: undefined,
    lastName: undefined,
    expirationDate: undefined,
  },
  adminUser:{
  username:undefined,
  userRole:undefined,
  email:undefined,
  firstName:undefined,
  lastName:undefined,
  }
}

// export const userLogin = createAsyncThunk<User, LoginData, ThunkApiConfig>(
//   'authentications/userLogin',
//   async (data: LoginData, thunkAPI) => {
//     try {
//       const response = await axios.post(loginURL, data);
      // if (response.data) {
      //   const user: User = {
      //     token: response.data.token,
      //     email: response.data.email,
      //     userRole: response.data.userRole,
      //     userID: response.data.id,
      //     userName: response.data.username,
      //     firstName: response.data.firstName,
      //     lastName: response.data.lastName,
      //     expirationDate: response.data.tokenExpiryTime,
      //   };
      //   localStorage.setItem('user', JSON.stringify(user));
      // }
//       return response.data;
//     } catch (error) {
      // const axiosError = error as AxiosError;
      // const message: ErrorMessage = {
      //   error:
      //     (axiosError.response && axiosError.response.data && axiosError.response.data.message) ||
      //     axiosError.message ||
      //     axiosError.toString(),
      //   message: axiosError.response?.data?.detail?.message,
      // };
      // return thunkAPI.rejectWithValue(message);
//     }
//   }
// );

export const activateUser = createAsyncThunk<User, UserDataForActivate, { rejectValue: ErrorMessage }>(
  "authentications/activateUser",
  async (data:UserDataForActivate, thunkAPI) => {

    try {
      const response = await axios.post(activateUserURL, data);
      if (response.data) {
        const user: User = {
          token: response.data.token,
          email: response.data.email,
          userRole: response.data.userRole,
          username: response.data.username,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          userID: response.data.userID,
          expirationDate: response.data.expirationDate,
        };
        localStorage.setItem('user', JSON.stringify(user));
      }
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
        // console.log((axiosError.response?.data as any).detail?.message)
      const message: ErrorMessage = {
        error:"error",
        message: (axiosError.response?.data as any).detail?.message
      };
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const logoutUser = createAsyncThunk<User, UserDataForLogoutUser, { rejectValue: ErrorMessage }>(
  "authentications/logoutUser",
  async (data:UserDataForLogoutUser, thunkAPI) => {

    try {
      localStorage.removeItem("user")
      thunkAPI.dispatch(destroyToten());
      thunkAPI.dispatch(updateUser(null))
      const response = await axios.get(`${logoutUserURL}${data.token}/`);

      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
        // console.log((axiosError.response?.data as any).detail?.message)
      const message: ErrorMessage = {
        error:"error",
        message: (axiosError.response?.data as any).detail?.message
      };
      return thunkAPI.rejectWithValue(message);
    }
  }
);




export const createUser = createAsyncThunk<User, AdminUser, { rejectValue: ErrorMessage }>(
  "authentications/createUser",
  async (data:AdminUser, thunkAPI) => {
    try {
      const response = await axios.post(createUserURL, data);
      if (response.data) {
        const user: User = {
          token: response.data.token,
          email: response.data.email,
          userRole: response.data.userRole,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          userID: response.data.userID,
          username: response.data.usersame,
          expirationDate: response.data.expirationDate
        };
        localStorage.setItem('user', JSON.stringify(user));
      }
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      const message: ErrorMessage = {
        error:"error",
        message: (axiosError.response?.data as any).detail?.message
      };
      return thunkAPI.rejectWithValue(message);
    }
  }
);



export const userLogin = createAsyncThunk<User, LoginData, { rejectValue: ErrorMessage }>(
  "authentications/userLogin",
  async (data:LoginData, thunkAPI) => {
    try {
      const response = await axios.post(loginURL, data);
      if (response.data) {
        const user: User = {
          token: response.data.token,
          email: response.data.email,
          userRole: response.data.userRole,
          userID: response.data.id,
          username: response.data.username,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          expirationDate: response.data.tokenExpiryTime,
        };
        localStorage.setItem('user', JSON.stringify(user));
      }
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      // console.log(axiosError)
      const message: ErrorMessage = {
        error:"error",
        message: (axiosError.response?.data as any).detail?.message
      };
      // console.log(message)
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const authenticationsSlice = createSlice({
  name: 'authentications',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<null>) => {
      let user_ = localStorage.getItem("user")
      if(user_){
        let user = JSON.parse(user_)
        state.user = user
      }
    },
    destroyToten: (state) =>{
      state.tokenValid = false;
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.pending, (state) => {
        state.status = 'loading';
        state.error = undefined;
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload;
        state.tokenValid = true;
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Something went wrong';
        state.message = action.error.message || 'Something went wrong';
        console.log("Failed to login-----")
        console.log(action.error)
        state.tokenValid = false;
      })
      .addCase(createUser.pending, (state) => {
        state.createAdminStatus = 'loading';
        state.error = undefined;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.createAdminStatus = 'succeeded';
        state.adminUser = action.payload;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.createAdminStatus = 'failed';
        state.error = action.error.message || 'Something went wrong';
        state.message = action?.payload?.message || 'Something went wrong';
        state.adminUser = initialState.adminUser;
      })
      .addCase(activateUser.pending, (state) => {
        state.status = 'loading';
        state.error = undefined;
        state.activateUserStatus = 'loading';
      })
      .addCase(activateUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.activateUserStatus = 'succeeded';
        state.user = action.payload;
      })
      .addCase(activateUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Something went wrong';
        state.activateUserStatus = 'failed';
      })


      ;
    }
})


export default authenticationsSlice.reducer


export const {
  updateUser,
  destroyToten,
} = authenticationsSlice.actions
